import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Banner from 'components/Banner';
import Layout from 'components/Layout';
import { Link } from 'gatsby';
import Meta from 'components/Meta';
import Image from 'components/Image';
import ScrollDown from 'components/ScrollDown';
import SectionContact from 'components/SectionContact';
import SectionReview from 'components/SectionReview';
import Speed from 'images/atc-ventures/speed.svg';
import Growth from 'images/atc-ventures/growth.svg';
import Product from 'images/atc-ventures/product.svg';
import Dots from 'images/atc-ventures/dots.svg';
import Ai from 'images/atc-ventures/ai.svg';
import Blockchain from 'images/atc-ventures/blockchain.svg';
import Cloud from 'images/atc-ventures/cloud.svg';
import Edtech from 'images/atc-ventures/edtech.svg';
import Hrtech from 'images/atc-ventures/hrtech.svg';
import Energy from 'images/atc-ventures/energy.svg';
import Tickmark from 'images/atc-ventures/approach.svg';
import Oval from 'images/atc-ventures/Oval.svg';
import EmailATC from 'images/atc-ventures/email-atc.svg';
import { Contact } from 'components/SectionContact/SectionContact.styled';
import FloatingText from 'components/FloatingText';
// import HubspotForm from 'react-hubspot-form';

import { VenturesContainer } from 'styles/ventures';

const AtcVenturesPage = ({ path }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://american-technology40184.activehosted.com/f/embed.php?id=1';
    script.type = 'text/javascript';
    script.charset = 'utf-8';

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return (
  <>
    <Meta title="ATC Ventures | Helping early stage startups to game-changing breakthroughs"
      description="We work with visionary founders of early-stage startups to amplify their intrinsic talent. And help them with globally tested Go-to-Market strategies." />
    <Layout lightTheme path={path}>
      <VenturesContainer>
        <section className="white-bg-section">
          <div className="container">
            <div className="ventures-main">
              <div className="row">
                <div className="col-md-6 ventures ventures-head">
                  <h2 className="medium-heading">
                    {' '}
                    Inviting
                    <span className="pink"> Inventive </span>
                    Entrepreneurs
                  </h2>
                  <p className="ventures-main-p">
                    We’ve mastered the art of steering early-stage startups to
                    game-changing breakthroughs.
                  </p>
                  <p>
                    <Link
                      to="/contact-us/"
                      className="button center d-inline-block"
                    >
                      Get In Touch
                    </Link>
                  </p>
                </div>
                <div className="col-md-5 offset-md-1">
                  <div className="ventures-thumb">
                    <Image
                      src="atc-ventures/ventures-1.jpg"
                      alt="atc-ventures"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="white-bg-section">
          <div className="container">
            <div className="ventures ventures-single-step">
              <h1 className="medium-heading">About ATC Ventures</h1>
              <p className="ventures-single-step-p">
                We are a team of entrepreneurs and investors with a passion for
                SaaS products and have built multiple tech startups from the
                ground up. We specialize in taking up early-stage startups and
                team them up with globally tested Go-to-Market strategies and
                established international networks.
              </p>
            </div>
          </div>
        </section>

        <section className="white-bg-section">
          <div className="container">
            <div className="ventures ventures-single-step">
              <div className="d-block d-md-flex justify-content-between align-items-center">
                <div className="d-block align-items-center flex-wrap p-md-0 py-3">
                  <div className="venture-about-icon">
                    <Speed width="62px" />
                  </div>
                  <div>
                    <h2 className="venture-about-title">Speed to Market</h2>
                    <p className="venture-about-desc">
                      Our Release-Now drive guarantees your products reaching
                      customers quickly.
                    </p>
                  </div>
                </div>
                <div className="d-block align-items-center flex-wrap flex-lg-nowrap p-md-0 py-3">
                  <div className="venture-about-icon">
                    <Growth width="62px" />
                  </div>
                  <div>
                    <h2 className="venture-about-title">Growth Mindset</h2>
                    <p className="venture-about-desc">
                      Mindset is everything. We aid entrepreneurs to scale 10X
                      in just the first 3 years.
                    </p>
                  </div>
                </div>
                <div className="d-block align-items-center flex-wrap flex-lg-nowrap p-md-0 py-3">
                  <div className="venture-about-icon">
                    <Product width="62px" />
                  </div>
                  <div>
                    <h2 className="venture-about-title">Product Launch</h2>
                    <p className="venture-about-desc">
                      We help kick-start your products in the Valley, the dream
                      destination for tech.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="white-bg-section">
          <div className="ventures ventures-vision">
            <div className="container">
              <div className="pos-rel">
                <div className="row">
                  <div className="col-md-7">
                    <div>
                      <span className="vision-bg-title">
                        YOUR VOICE MATTERS AS MUCH AS OURS &nbsp;&nbsp;
                        <span className="dash" />
                      </span>
                      <Image src="atc-ventures/vision.png" alt="atc-ventures" />
                    </div>
                  </div>
                  <div className="col-md-4" style={{ margin: 'auto 0' }}>
                    <div className="abt-second-desc">
                      <h1 className="vision-bg">Vision</h1>
                      <h2 className="medium-heading">Vision</h2>
                      <p>
                        Our objective is to enable early-stage entrepreneurs to
                        go global and solve problems at scale.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="white-bg-section">
          <div className="ventures ventures-approach">
            <Dots className="dots" />
            <div className="pos-rel">
              <div className="row approach-container">
                <div className="col-md-4">
                  <h1 className="big-heading"> Our Approach</h1>
                  <div
                    className="row"
                    style={{ marginTop: 60, marginLeft: 10 }}
                  >
                    <div>
                      <Tickmark
                        style={{ position: 'absolute', marginTop: 12 }}
                      />
                      <div style={{ marginLeft: 37 }}>
                        <span className="approach-list-title">
                          Founder-friendly, we know what it takes
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ marginTop: 20, marginLeft: 10 }}
                  >
                    <div style={{ paddingTop: 10, paddingRight: 5 }}>
                      <Tickmark
                        style={{ position: 'absolute', marginTop: 12 }}
                      />
                      <div style={{ marginLeft: 37 }}>
                        <span className="approach-list-title">
                          Accept that teams are diverse and inclusive
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ marginTop: 20, marginLeft: 10 }}
                  >
                    <div style={{ paddingTop: 10, paddingRight: 5 }}>
                      <Tickmark
                        style={{ position: 'absolute', marginTop: 12 }}
                      />
                      <div style={{ marginLeft: 37 }}>
                        <span className="approach-list-title">
                          Fund entrepreneurs with vision and passion to go
                          all-in till the end
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ marginTop: 20, marginLeft: 10 }}
                  >
                    <div style={{ paddingTop: 10, paddingRight: 5 }}>
                      <Tickmark
                        style={{ position: 'absolute', marginTop: 12 }}
                      />
                      <div style={{ marginLeft: 37 }}>
                        <span className="approach-list-title">
                          Grow your team by helping you bring in the right
                          talent onboard
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ marginTop: 20, marginLeft: 10 }}
                  >
                    <div style={{ paddingTop: 10, paddingRight: 5 }}>
                      <Tickmark
                        style={{ position: 'absolute', marginTop: 12 }}
                      />
                      <div style={{ marginLeft: 37 }}>
                        <span className="approach-list-title">
                          Identify the product-market fit and help understand
                          the customer
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-7 col-sm-11" style={{ marginTop: 82 }}>
                  <Image
                    backgroundColor="transparent"
                    objectFit="contain"
                    src="atc-ventures/approach.jpg"
                    alt="atc-ventures"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="grey-bg-section">
          <div className="container">
            <div className="ventures-invest">
              <h1 className="medium-heading">
                What We Invest In
                <span className="pink">.</span>
              </h1>
              <div className="row" style={{ marginTop: 60 }}>
                <div className="col-md-5">
                  <div className="rectangle">
                    <Ai />
                    <span className="invest-step">Artificial Intelligence</span>
                  </div>
                </div>
                <div className="col-md-5 offset-md-2 invest-second-step">
                  <div className="rectangle">
                    <Blockchain />
                    <span className="invest-step">Blockchain</span>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: 60 }}>
                <div className="col-md-5">
                  <div className="rectangle">
                    <Cloud />
                    <span className="invest-step">Cloud & Kubernetes</span>
                  </div>
                </div>
                <div className="col-md-5 offset-md-2 invest-second-step">
                  <div className="rectangle">
                    <Edtech />
                    <span className="invest-step">Ed Tech</span>
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: 60 }}>
                <div className="col-md-5">
                  <div className="rectangle">
                    <Energy />
                    <span className="invest-step">Energy</span>
                  </div>
                </div>
                <div className="col-md-5 offset-md-2 invest-second-step">
                  <div className="rectangle">
                    <Hrtech />
                    <span className="invest-step">HR Tech</span>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 60 }}>
                <a href="/contact-us/" className="pink-btn">
                  <span>Talk to us</span>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="ventures-lookfor">
            <h1 className="ventures-lookfor-title">What We Look For?</h1>
            <hr className="horizontal-line" />
            <div className="row" style={{ marginTop: 40, marginLeft: 10 }}>
              <div style={{ paddingTop: 10, paddingRight: 5 }}>
                <Oval style={{ position: 'absolute', marginTop: 12 }} />
                <div style={{ marginLeft: 37 }}>
                  <span className="lookfor-item">
                    Early-stage startups where entrepreneurs can demonstrate the
                    product-market fit
                  </span>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: 25, marginLeft: 10 }}>
              <div style={{ paddingTop: 10, paddingRight: 5 }}>
                <Oval style={{ position: 'absolute', marginTop: 12 }} />
                <div style={{ marginLeft: 37 }}>
                  <span className="lookfor-item">
                    Startups with a minimum viable product (MVP) and a strong
                    tech team
                  </span>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: 25, marginLeft: 10 }}>
              <div style={{ paddingTop: 10 }}>
                <Oval style={{ position: 'absolute', marginTop: 12 }} />
                <div style={{ marginLeft: 37 }}>
                  <span className="lookfor-item">
                    Founders who are prepared to move to Silicon Valley
                  </span>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: 25, marginLeft: 10 }}>
              <div style={{ paddingTop: 10 }}>
                <Oval style={{ position: 'absolute', marginTop: 12 }} />
                <div style={{ marginLeft: 37 }}>
                  <span className="lookfor-item">Funding up to $500K</span>
                </div>
              </div>
            </div>
            <div style={{ marginTop: 75 }}>
              <Link to="/contact-us/" className="button center d-inline-block">
                Get In Touch
              </Link>
            </div>
          </div>

          <Image
            backgroundColor="transparent"
            objectFit="contain"
            src="atc-ventures/invest.jpg"
            alt="atc-ventures"
          />
        </section>

        <section className="white-bg-section">
          <div className="ventures ventures-step">
            <Dots style={{ position: 'absolute', marginLeft: 30 }} />
            <div className="pos-rel">
              <div className="row" style={{ marginLeft: 108 }}>
                <div className="col-md-4">
                  <h1 className="big-heading">
                    {' '}
                    Meet the team
                    <span className="pink">.</span>
                  </h1>
                </div>
                <div
                  className="col-md-7 col-sm-11"
                  style={{ marginTop: 82 }}
                ></div>
              </div>
              <div className="row team-section">
                <div className="col-md-4">
                  <Image
                    style={{ marginBottom: 50 }}
                    src="atc-ventures/team-1.jpg"
                    alt="atc-ventures"
                  />
                  <p className="team-name">Darryl Jose</p>
                  <span className="team-desc">
                    With a passion for Saas products and over 20 years of
                    experience in building, promoting and scaling startups,
                    Darryl has raised several bootstrapped, self-funded
                    startups.
                  </span>
                </div>
                <div className="col-md-4 team-2">
                  <Image
                    style={{ marginBottom: 50 }}
                    src="atc-ventures/team-2.jpg"
                    alt="atc-ventures"
                  />
                  <p className="team-name">Bhanu Valluri</p>
                  <span className="team-desc">
                    CoFounder for Auzmor and advisor for many B2B product
                    startups, Bhanu is a serial entrepreneur with startups in
                    security, voice assistant and employee experience space.
                  </span>
                </div>
                <div className="col-md-4 team-2">
                  <Image
                    style={{ marginBottom: 50 }}
                    src="atc-ventures/team-3.jpg"
                    alt="atc-ventures"
                  />
                  <p className="team-name">Bardia Moayedi</p>
                  <span className="team-desc">
                    Bardia is an expert on corporate and securities law, with a
                    primary emphasis on advising emerging growth and public
                    companies throughout their life cycles.
                  </span>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </section>
        <Contact style={{ marginTop: 75, marginRight: 5 }}>
          <div className="circle-1"></div>
          <div className="circle-2"></div>
          <div className="circle-3"></div>
          <div className="contact-container">
            <h1 className="big-heading">Hi there, reach out to us.</h1>
            <FloatingText dark="dark" text="Over a coffee" />
            <div className="row" style={{ margin: '96px 0' }}>
              <div className="col-md-5 ventures-contact-form">
              <div className="_form_1"></div>
                {/* <HubspotForm
                  portalId="2117583"
                  formId="668712ee-b4cf-41a9-a76a-0d1edafa29a1"
                /> */}
              </div>
              <div className="col-md-4 offset-md-1 contact-text">
                <p className="contact-desc">
                  Alternatively, you can email your questions or business plans
                  here:
                </p>
                <span>
                  <p className="contact-email">
                    <EmailATC style={{ verticalAlign: 'middle' }} /> &nbsp;
                    ventures@american-technology.net
                  </p>
                </span>
              </div>
            </div>
          </div>
        </Contact>
      </VenturesContainer>
    </Layout>
  </>
)};

AtcVenturesPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default AtcVenturesPage;
